module.exports = __webpack_public_path__ + "img/imagebanner3.5cdddfe9.png";